import { render, staticRenderFns } from "./view-approved-salary-routine.vue?vue&type=template&id=88c69780&"
import script from "./view-approved-salary-routine.vue?vue&type=script&lang=js&"
export * from "./view-approved-salary-routine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports